module.exports = __webpack_public_path__ + "img/10979918_L.23d0cd11.png";